module.exports = __webpack_public_path__ + "img/logan-post1.10609f63.jpeg";